import { User } from 'lucide-react'

interface AvatarProps {
  src?: string
  alt?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const sizeClasses: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'size-8',
  md: 'size-10',
  lg: 'size-16',
  xl: 'size-24',
}

const iconSizes: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-8',
  xl: 'size-12',
}

export default function Avatar({
  src,
  alt = '',
  size = 'md',
  className = '',
}: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`rounded-full object-cover bg-gray-200 ${sizeClasses[size]} ${className}`}
      />
    )
  }

  return (
    <div
      className={`rounded-full bg-gray-200 flex items-center justify-center ${sizeClasses[size]} ${className}`}
    >
      <User className={`text-gray-400 ${iconSizes[size]}`} />
    </div>
  )
}
